"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockTechniqueDetail = exports.mockTechniqueFull = exports.mockTechnique = void 0;
function mockTechnique(overrides = {}) {
    return {
        id: 1,
        display_name: 'mock display_name',
        name: 'mock name',
        ...overrides,
    };
}
exports.mockTechnique = mockTechnique;
function mockTechniqueFull(overrides = {}) {
    return {
        banner_image: 'http://example.com/banner.jpg',
        display_name_alternate: 'mock display_name_alternate',
        categories: ['hardbaits'],
        color: '#ff0000',
        description: 'mock description',
        image: 'http://example.com/jiggin.jpg',
        img_alt: 'mock img_alt',
        meta_description: 'mock meta_description',
        meta_title: 'mock meta_title',
        page_heading: 'mock page_heading',
        page_subheading: 'mock page_subheading',
        seasons: ['spawn'],
        species: ['trout'],
        subcategories: ['hardbaits-bladebaits'],
        subcat_types: ['reels-spinning-spinning'],
        url_path: 'mock_url_path',
        ...mockTechnique(overrides),
        ...overrides,
    };
}
exports.mockTechniqueFull = mockTechniqueFull;
function mockTechniqueDetail(overrides = {}) {
    return {
        ...mockTechniqueFull(overrides),
        ambassador_lists: [],
        links: [],
        ...overrides,
    };
}
exports.mockTechniqueDetail = mockTechniqueDetail;
